import { useEffect, useState } from 'react';
import { LeftNav } from './Base';
import { Outlet, useLocation } from 'react-router-dom';
import api from '../API';
import { useOrgWorkspaceNav } from '../providers/useOrgWorkspaceNav';

/**
 * Projects hub shell. Always mounts LeftNav around <Outlet /> so toggling
 * hub/section links (e.g. when org branding loads) never remounts route pages.
 */
function ProjectsLayout() {
    const location = useLocation();
    const { isOrgWorkspace } = useOrgWorkspaceNav();
    const parts = location.pathname.split('/').filter(Boolean);

    const isOrgLandingRoute =
        parts[0] === 'projects' && parts[1] === 'org';

    /** /projects/:folderId — project settings (not manage / org / nested segments) */
    const isProjectSettingsPage =
        parts.length === 2
        && parts[0] === 'projects'
        && parts[1] !== 'manage'
        && parts[1] !== 'org';

    // Hide hub links for org landing (by route) and for org-branded project pages.
    const hideHubNav = isOrgLandingRoute || isOrgWorkspace;

    const [browseAccess, setBrowseAccess] = useState({ resolved: false, allowed: false });

    useEffect(() => {
        let cancelled = false;
        api.get('projects/root', {})
            .then((r) => {
                if (!cancelled) {
                    setBrowseAccess({ resolved: true, allowed: r.status === 200 });
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setBrowseAccess({ resolved: true, allowed: false });
                }
            });
        return () => {
            cancelled = true;
        };
    }, []);

    const sectionLinks = isProjectSettingsPage
        ? [
            { text: 'Project status', sectionId: 'project-section-visibility', sectionNavStart: true },
            { text: 'Participants', sectionId: 'project-section-participants' },
            { text: 'Annotation UI', sectionId: 'project-section-annotation-ui' },
            { text: 'Items', sectionId: 'project-section-items' },
            { text: 'Regions of interest', sectionId: 'project-section-roi' },
        ]
        : [];

    const hubNavLinks = hideHubNav
        ? []
        : [
            { text: 'My projects', to: '/projects', end: true },
            ...(browseAccess.resolved && browseAccess.allowed
                ? [{ text: 'Browse and organize', to: '/projects/manage' }]
                : []),
        ];

    const navLinks = [...hubNavLinks, ...sectionLinks];

    return (
        <LeftNav navLinks={navLinks}>
            <Outlet />
        </LeftNav>
    );
}

export default ProjectsLayout;
